<template>
  <div class="box">
    <div class="main-content">
      <!-- 切换功能 -->
      <div class="main-content-top">
        <div @click="selectViewBox(index)" v-for="(item, index) in dataView" :key="index" class="viewBox flex align justify pointer">
          <img v-if="index != 3" class="viewBox-img" :src="item.check ? item.imgCheckSrc : item.imgSrc" />
          <img v-if="index == 3" class="viewBox-img1" :src="item.check ? item.imgCheckSrc : item.imgSrc" />
        </div>
      </div>
      <!-- 按学生查看部分开始 -->
      <studentView v-if="dataView[0].check"></studentView>
      <!-- 按学生查看部分结束 -->
      <!-- 按课次查看部分开始 -->
      <classNumView v-if="dataView[1].check"></classNumView>
      <!-- 按课次查看部分结束 -->
      <!-- 按资源查看部分开始 -->
      <resourceView v-if="dataView[2].check"></resourceView>
      <!-- 按资源查看部分结束 -->
      <!-- 查看考试数据部分开始 -->
      <testPaperData class="testPaperData-box" v-if="dataView[3].check"></testPaperData>
      <!-- 查看考试数据部分结束 -->
    </div>
  </div>
</template>

<script>
// 按学生查看组件
import studentView from "@/views/studentStatistics/studentView.vue";
// 按课次查看组件
import classNumView from "@/views/studentStatistics/classNumView.vue";
// 按资源查看组件
import resourceView from "@/views/studentStatistics/resourceView.vue";
// 查看考试数据
import testPaperData from "@/views/courseTeaching/testPaperData/index.vue";
export default {
  data() {
    return {
      dataView: [
        // 切换功能列表
        {
          check: true,
          imgSrc: require("../../assets/studentStatisticsIcon/unStudentView.png"),
          imgCheckSrc: require("../../assets/studentStatisticsIcon/studentView.png"),
        },
        {
          check: false,
          imgSrc: require("../../assets/studentStatisticsIcon/unClassNumView.png"),
          imgCheckSrc: require("../../assets/studentStatisticsIcon/classNumView.png"),
        },
        {
          check: false,
          imgSrc: require("../../assets/studentStatisticsIcon/unResourceView.png"),
          imgCheckSrc: require("../../assets/studentStatisticsIcon/resourceView.png"),
        },
        {
          check: false,
          imgSrc: require("../../assets/studentStatisticsIcon/unTestPaperData.png"),
          imgCheckSrc: require("../../assets/studentStatisticsIcon/testPaperData.png"),
        },
      ],
    };
  },
  components: { studentView, classNumView, resourceView, testPaperData },
  created() {},
  methods: {
    // 选择查看方式
    selectViewBox(index) {
      this.dataView[0].check = false;
      this.dataView[1].check = false;
      this.dataView[2].check = false;
      this.dataView[3].check = false;
      this.dataView[index].check = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
}
.main-content {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
}
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
.main-content-top {
  width: 1740px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bfbfbf;
}
.viewBox {
  width: 244px;
  height: 40px;
  border-right: 1px solid #bfbfbf;
}
.viewBox:last-child {
  width: 274px;
  height: 40px;
  border-right: 0px solid #bfbfbf;
}
.viewBox-img {
  width: 165px;
  height: 24px;
}
.viewBox-img1 {
  width: 191px;
  height: 24px;
}

.testPaperData-box {
  height: calc(100% - 85px);
}
</style>
